import {ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, OnInit} from '@angular/core';
import {takeUntil, tap} from 'rxjs/operators';
import {destroy$} from '../destroyable';
import {LinkToSimulatorService} from './link-to-simulator.service';

const IS_LINK_AVAILABLE_CLASS = '-visible';

@Component({
    selector: 'link-to-simulator',
    templateUrl: './link-to-simulator.component.html',
    styleUrls: ['./link-to-simulator.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LinkToSimulatorComponent implements OnInit {

    @HostBinding(`class.${IS_LINK_AVAILABLE_CLASS}`)
    public isLinkAvailable: boolean = false;

    public readonly linkUrl: string = this.linkToSimulatorService.linkUrl;

    public readonly destroy$ = destroy$();

    constructor(
        private linkToSimulatorService: LinkToSimulatorService,
        private changeDetectorRef: ChangeDetectorRef
    ) {}

    public ngOnInit(): void {
        this.listenToLinkAvailability();
    }

    public navigateToSimulator(event: MouseEvent): void {
        event.preventDefault();

        this.linkToSimulatorService.navigateToSimulator();
    }

    private listenToLinkAvailability(): void {
        this.linkToSimulatorService.getLinkAvailabilityStream().pipe(
            tap(isLinkAvailable => {
                this.isLinkAvailable = isLinkAvailable;
                this.changeDetectorRef.markForCheck();
            }),
            takeUntil(this.destroy$)
        ).subscribe();
    }

}
